import React from 'react';
import { Dialog, Intent, Classes, Button, DialogProps, ButtonProps } from '@blueprintjs/core';
import type  { BasicErrorStore } from '../../data/app/BasicErrorStore';
import { observer } from 'mobx-react-lite';

/**
 * ErrorDialog
 */
export const ErrorDialog: React.FC<Readonly<{
    dialogProps?: DialogProps;
    buttonProps?: ButtonProps;
    showStack?: boolean;
    errors: BasicErrorStore;
}>> = observer(props => {

    if (props.errors.isEmpty) return null;
    const { error } = props.errors.data;

    // --

    return (
        <Dialog
            {...(props.dialogProps ?? {})}
            isOpen={true}
            className='uk-padding-remove'
            style={{background: '#fff'}}
        >
            <div className={Classes.DIALOG_BODY}>
                <h3 className='uk-text-danger'>{error instanceof Error ? error.constructor.name : 'Error'}</h3>

                <p className='uk-text-bold' dangerouslySetInnerHTML={{ __html: error.name }} />
                <i dangerouslySetInnerHTML={{ __html: error.message }} />

                {props.showStack && props.errors.stack ? (
                    <div className='uk-text-margin-small-top'>
                        <div className='uk-text-bold'>
                            Stack:
                            <hr />
                        </div>

                        <div className='uk-height-large uk-overflow-auto'>
                            {props.errors.stack}
                        </div>
                    </div>
                ) : null}

                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button
                        intent={Intent.PRIMARY}
                        text='Close'
                        {...(props.buttonProps ?? {})}
                        onClick={props.errors.clear}
                    />
                </div>
            </div>
        </Dialog>
    )
})

